import { assertEvent, assign } from 'xstate5';

import { setFailureAlreadyShown } from '../utils';
import { type OrderingMachineAction } from './ordering-machine.actions.types';
import { orderingMachineLog } from './ordering-machine.logger';

// ─────────────────────────────────────────────────────────────────────────────

const setHasTriggeredOrderSubmission: OrderingMachineAction = assign({
  hasTriggeredOrderSubmission: true,
});

const clearHasTriggeredOrderSubmission: OrderingMachineAction = assign({
  hasTriggeredOrderSubmission: false,
});

const onOrderPaymentStateDone: OrderingMachineAction = assign({
  paymentMethodOrIntentId({ context, event }) {
    assertEvent(event, 'xstate.done.actor.fetchOrderPaymentState');
    return event.output.paymentIntentId || context.paymentMethodOrIntentId;
  },
  paymentStateExpiration({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchOrderPaymentState');
    return event.output.paymentStateExpiration;
  },
  paymentStateStatus({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchOrderPaymentState');
    return event.output.paymentStateStatus;
  },
  paymentStateError({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchOrderPaymentState');
    return event.output.paymentStateError;
  },
});

const onOrderPaymentStateError: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `onOrderPaymentStateError` action.');
};

const onFetchStatePostOrderDone: OrderingMachineAction = assign({
  orderId({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchStatePostOrder');
    return event.output.order.id;
  },
  hasEarnedLoyaltyPoints({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchStatePostOrder');
    return event.output.order.hasEarnedLoyaltyPoints;
  },
  cart({ event }) {
    assertEvent(event, 'xstate.done.actor.fetchStatePostOrder');
    return event.output.cart;
  },
});

const setConfirmStripe: OrderingMachineAction = assign({
  confirmStripe({ event }) {
    assertEvent(event, 'SET_CONFIRM_STRIPE');
    return event.params.confirmStripe;
  },
});

const confirmStripe: OrderingMachineAction = ({ context }) => {
  context.confirmStripe();
};

const setStripeFailureAsAlreadyShown: OrderingMachineAction = ({ context }) => {
  void setFailureAlreadyShown(context.paymentMethodOrIntentId);
};

const changePaymentMethod: OrderingMachineAction = assign({
  paymentMethodOrIntentId({ context, event }) {
    if (!('params' in event) || !event.params) {
      return context.paymentMethodOrIntentId;
    }

    if (!('paymentMethodId' in event.params) || !event.params.paymentMethodId) {
      return context.paymentMethodOrIntentId;
    }

    return event.params.paymentMethodId;
  },
});

const incrementPurchaseAttempt: OrderingMachineAction = assign({
  purchaseAttempt({ context }) {
    return context.purchaseAttempt + 1;
  },
});

const clearLocalStorageOrderId: OrderingMachineAction = () => {
  orderingMachineLog.debug('Please provide `clearLocalStorageOrderId` action.');
};

// ─────────────────────────────────────────────────────────────────────────────

export const OrderingPaymentActions = {
  setHasTriggeredOrderSubmission,
  clearHasTriggeredOrderSubmission,
  onOrderPaymentStateDone,
  onFetchStatePostOrderDone,
  setConfirmStripe,
  confirmStripe,
  setStripeFailureAsAlreadyShown,
  changePaymentMethod,
  incrementPurchaseAttempt,
  onOrderPaymentStateError,
  clearLocalStorageOrderId,
};
